export default __webpack_public_path__ + "static/mingling-d70d1b5565da514d27fbf0e1c613d980.svg";